import { isCameraShareEnabled, isScreenShareEnabled } from "./media-sharing-config-utils";

export const ROOM_ENTRY_AUTHORITY = Object.freeze({
  DIALOG: "dialog",
  RETICULUM: "reticulum"
});

export const RETICULUM_ADMISSION_STATUS = Object.freeze({
  AVAILABLE: "available",
  CAPACITY_FULL: "capacity_full",
  PRESENCE_UNAVAILABLE: "presence_unavailable"
});

function currentSearch() {
  return typeof window === "undefined" ? "" : window.location?.search || "";
}

export function isWebRtcDisabled(search = currentSearch()) {
  return new URLSearchParams(search).get("webrtc") === "0";
}

export function requiresDialogConnection(config = {}, search) {
  if (isWebRtcDisabled(search)) return false;

  return (
    config?.voiceChat?.enabled !== false ||
    config?.textChat?.enabled !== false ||
    isCameraShareEnabled(config) ||
    isScreenShareEnabled(config)
  );
}

export function shouldShowEntryAudioSetup(config = {}, search) {
  return requiresDialogConnection(config, search);
}

export function getRoomEntryAuthority(config = {}, search) {
  return requiresDialogConnection(config, search) ? ROOM_ENTRY_AUTHORITY.DIALOG : ROOM_ENTRY_AUTHORITY.RETICULUM;
}

export function getReticulumRoomEntryAdmission({ hub, hubChannel }) {
  if (
    !hubChannel?.channel?.isJoined?.() ||
    !hubChannel?.presence?.state ||
    typeof hubChannel.canEnterRoom !== "function"
  ) {
    return RETICULUM_ADMISSION_STATUS.PRESENCE_UNAVAILABLE;
  }

  return hubChannel.canEnterRoom(hub) ? RETICULUM_ADMISSION_STATUS.AVAILABLE : RETICULUM_ADMISSION_STATUS.CAPACITY_FULL;
}
